/**
 * Directive: printerFriendlyLink
 */
angular.module('acme.common.directive.printerFriendlyLink', [
  'acme.common.service.helpers',
  'acme.common.service.api',
  'ui.bootstrap',
  'agGrid'
])
  .directive('printerFriendlyLink', ['$uibModal', '$timeout', '$filter', 'ApiService', 'HelpersService', 'AuditTrailService', 'GridStateFactory', function ($uibModal, $timeout, $filter, ApiService, HelpersService, AuditTrailService, GridStateFactory) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/printerFriendlyLink/printerFriendlyLink.tpl.html',
      scope: {
        action: '&'
      },

      link: function ($scope, $element, $attrs) {
        // Modified after controller runs
      },

      controller: ['$scope', function ($scope) {

        $scope.printerFriendlyLink = {

          action: function () {
            if (typeof($scope.action) === 'function') {
              $scope.action();
            }
          }

        };

      }]

    };

  }]);